<template>
  <div :class="checkWidth() + ' ' + 'container'">
    <template v-if="loading">
      <div class="container vertical-center">
        <LoadingMDL />
      </div>
    </template>
    <template v-else>
      <CRow alignHorizontal="center" alignVertical="center">
        <CCol col="1">
          <CRow alignHorizontal="end">
            <div
              class="containerIconLeft"
              @click="funcRouteBack(content.navigate.previous.action)"
            >
              <font-awesome-icon
                class="IconLeft"
                icon="chevron-left"
                size="1.5"
              ></font-awesome-icon>
            </div>
          </CRow>
        </CCol>
        <CCol col="10">
          <CardMatrix
            :cardContent="content"
            :checkWidth="widthScreen.toString()"
            :typeInfo="typeInfo"
            :info="info"
            :cardSetting="cardSetting"
            :MatrixTones="MatrixTones"
            @setIsRightActive="setIsRightActive"
            @setInfo="setInfo"
            @setAnwser="setAnwser"
            :initialAnswer="data"
            :AnswerChoice="answer"
          />
        </CCol>
        <CCol col="1">
          <CRow>
            <div
              :class="getNextButtonColor(isRightActive)"
              @click="getNextButtonAttribute(isRightActive)"
              class="containerIconRight"
            >
              <font-awesome-icon
                class="IconRight"
                icon="chevron-right"
                size="1.5"
              ></font-awesome-icon>
            </div>
          </CRow>
        </CCol>
      </CRow>
    </template>
  </div>
</template>

<script>
import CardMatrix from './components/CardMatrix.vue';
import '../../../assets/scss/_chineseStyle.scss';
import '../../../assets/scss/_chineseIcon.scss';
import {mapGetters} from 'vuex';
import TEMPLATE from '../../../TEMPLATE.vue';
import LoadingMDL from '../../../components/loading/LoadingMDL';

export default {
  components: {CardMatrix, TEMPLATE, LoadingMDL},
  name: 'IAM01',
  data() {
    return {
      initialCount: 0,
      isRightActive: false,
      isStepTwo: false,
      nextButton: Function,
      MatrixTones: 'VALUE',
      content: {},
      cardSetting: {
        infoType: 'text',
        choiceType: 'audio',
        answerType: 'one',
      },
      info: 'Initials',
      typeInfo: 'Initials',
      widthScreen: window.innerWidth,
      lang: this.$store.getters['language/getLanguage'],
      baseUrl: process.env.VUE_APP_URL_SOUND,
      courseCode: '',
      checkAnswer: [],
      count: 6,
      CheckWidth: window.innerWidth.toString(),
      loaded: false,
      userTemplateData: [],
      nextAction: [],
      pageCode: '',
      data: [],
      answer: [],
      InputAns: '',
      courseSection: '',
      startTime: '',
      condition: [],
      courseId: '',
      loading: false,
      v3Data: {},
      nextPath: null,
    };
  },

  computed: {
    ...mapGetters({
      allCourse: 'template/getTemplateContent',
      getUserTemplate: 'template/getUserTemplate',
      loadingGetter: 'template/loadingGetter',
      getTemplatev3: 'v3/getTemplates',
      saveContentStatusv4: 'v4-data/saveContentStatusv4',
    }),
  },

  watch: {
    getTemplatev3: function (val) {
      if (!val) return;

      this.v3Data = val;
      this.content = val.templates[0];

      if (!this.content.enable) {
        const pathFormat = this.content.navigate.close.action.split('-');
        alert('Access denied!');
        this.$router.push(`/v4/${pathFormat[0]}/${pathFormat[1]}`);
      }

      //check template and count
      this.checkTemplate();
      this.checkCount();

      this.data = Array(this.content?.content?.question[0]?.item?.length);
      this.answer = Array(
        this.content?.content?.question[0]?.choices[0]?.choice?.choices?.item
          ?.comment?.length
      );

      this.$store.dispatch('v4/checkCurrentMainCode', this.v3Data);

      this.loading = false;
    },
    saveContentStatusv4: function (val) {
      // console.log(val, 'IAM01 Watcher Call');
      if (this.nextPath) {
        this.loading = true;

        const splitPath = this.nextPath.split('-');
        const onNext = `/v4/${splitPath[0]}/${splitPath[1]}`;
        //to LTK 01
        this.$router.push(onNext);
      }
    },
    checkAnswer(value) {},
    initialCount(value) {
      //still works ?
      if (this.count <= value) this.setIsRightActive(true);
    },
    info(value) {
      //still works ?
      if (value == 'Initials') {
        this.setIsRightActive(false);
        this.initialCount = this.initialCount + 1;
      }
    },
    data: function (val) {
      //still work?
      for (let i = 0; i < val.length; i++) {
        if (i === 0) {
          this.InputAns = val[i];
        } else if (i > 0) {
          if (val[i] != undefined) {
            this.InputAns = this.InputAns + val[i];
          }
        }
      }
    },
  },

  mounted() {
    this.onLoad();
  },

  created() {},

  beforeDestroy() {
    // this.commitPayloadData();
  },
  methods: {
    onLoad() {
      this.courseCode = this.$store.getters['necessary/getLerningCourse'].code;
      this.courseId = this.$store.state.necessary.learningCourse;
      this.pageCode = `IAM01-` + this.$route.params.id;
      this.lang = this.$store.state.language.language;
      this.startTime = this.$helpers.getDateFormat();

      const contentId = `IAM01-${this.$route.params.id}`;
      this.$store.dispatch('v3/fetchTemplateByCode', contentId);
    },
    checkWidth() {
      if (this.CheckWidth > 800) {
        return 'container-chinese-card';
      } else if (this.CheckWidth <= 800) {
        return 'container-chinese-card-mobile';
      }
    },
    checkCount() {
      const tempId = this.content.codeTemplate;
      if (tempId === 'IAM01-1') {
        this.count = 5;
      } else if (tempId === 'IAM01-4') {
        this.count = 4;
      }
    },
    checkLangClass() {
      if (this.lang == 'CN') {
        return 'fontChinese';
      } else if (this.lang == 'PIN IN') {
        return 'fontPinin';
      } else {
        return '';
      }
    },
    funcRouteBack(tempId) {
      let str = tempId.split('-');
      let checkUrl = str[0];
      const previousPath = `/v4/${str[0]}/${str[1]}`;
      if (checkUrl === 'IAM01') {
        this.$router.push(previousPath);
      } else {
        this.$router.push(previousPath);
      }
    },
    funcRoute(tempId) {
      this.commitPayloadData(tempId);
    },
    setIsRightActive(status) {
      this.isRightActive = status;
    },
    getNextButtonColor(status) {
      if (status) return 'containerIconRight-matrix active';
      else return 'containerIconRight-matrix';
    },
    setAnwser(value) {
      var CorrectAnsLength =
        this.content.content.question[0].choices[0].choice.choices.item.comment
          .length;

      if (value.length >= CorrectAnsLength) {
        value = [];
        this.checkAnswer = [];
      } else {
        this.checkAnswer = value;
        this.InputAns = this.checkAnswer[0] + this.checkAnswer[1];
      }
    },
    setInfo(value) {
      this.info = value;
    },
    setNextButtonAttribute(func) {
      this.nextButton = func;
    },
    getNextButtonAttribute(status) {
      var tone = this.content.content.question[0].title[1].value;
      if (status && this.count <= this.initialCount) {
        let path = this.content.navigate.next.action;
        this.funcRoute(path);
      } else if ((this.isRightActive = true && this.MatrixTones == 'Tones')) {
        let path = this.content.navigate.next.action;
        this.funcRoute(path);
      } else if ((this.isRightActive = true && tone == 'Audio')) {
        //for multi matrix
        //sent loading to trigger watch
        this.compareAnswer();
        let path = this.content.navigate.next.action;
        this.funcRoute(path);
      } else if (status && this.count > this.initialCount) {
        this.setInfo('Initials');
      } else {
        alert('Please complete the assignment');
      }
    },
    checkTemplate() {
      var data = this.content.content.question[0].multiSelect;
      var tone = this.content.content.question[0].title[1].value;
      if (data == false && tone == 'Tone') {
        this.setIsRightActive(true);
        this.cardSetting = {
          infoType: 'text',
          choiceType: 'audio',
          answerType: 'one',
        };
        this.MatrixTones = 'Tones';
        this.info = 'Tones';
      } else if (data == true && tone == 'Audio') {
        this.setIsRightActive(true);
        this.cardSetting = {
          infoType: 'text',
          choiceType: 'audio',
          answerType: 'multi',
        };
        this.MatrixTones = '';
        this.typeInfo = 'audio';
        this.info = '';
      } else {
        this.cardSetting = {
          infoType: 'text',
          choiceType: 'audio',
          answerType: 'one',
        };
      }
    },
    compareAnswer() {
      if (
        this.pageCode === 'IAM01-6' ||
        this.pageCode === 'IAM01-7' ||
        this.pageCode === 'IAM01-8'
      ) {
        const CorrectAns =
          this.content?.content?.question?.[0]?.choices?.[0]?.choice?.choices
            ?.item?.comment;

        if (this.InputAns === CorrectAns) {
          // console.log('answer Correct');

          this.$store.commit('v3/v3CheckingResultTrue');
        } else {
          // console.log('answer not correct');

          this.$store.commit('v3/v3CheckingResultFalse');
        }
      }
    },
    commitPayloadData(path) {
      //for v4 planned ?
      //payload here
      const payload = {
        codeItem: this.v3Data.codeItem,
      };

      //commit add payload stack
      this.$store.commit('v4/addPayloadStack', payload);
      //var
      const currentDataStack = [...this.$store.state.v4.v4DataStack];
      const currentCodeItem = this.v3Data.codeItem;
      //get last code item form backend
      const lastCodeItem = this.v3Data.lastContent;
      //check store
      if (currentDataStack.length === 0) {
        //no dispatch if array empty
      } else {
        if (currentCodeItem === lastCodeItem) {
          // console.log('current Code = lastCode save content and clear stack');
          this.$store.dispatch('v4/v4ProgressAndScoreCalc', {
            mainCodeItem: this.v3Data.mainCodeItem,
            mainType: this.v3Data.mainType,
            mainContent: this.v3Data.mainContent,
            dataStack: currentDataStack,
            pages: this.v3Data.pages,
            courseId: this.$store.state.v3.v3EnrollData.data.courseinfo,
            section: this.$store.state.v3.v3EnrollData.data.section,
          });
          this.nextPath = path;
        } else {
          //onNext
          const str = path.split('-');
          const nextPath = `/v4/${str[0]}/${str[1]}`;
          this.$router.push(nextPath);
        }
      }
    },
  },
};
</script>
<style></style>
